import { Component, Input } from '@angular/core';

import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { Tournament } from '@frontend/sports/types/components/tournaments';

import { CompetitionRoute } from '../navigation/navigation.models';
import { CompetitionTreeComponent } from './competition-tree.component';

@Component({
    selector: 'ms-competition-navigation',
    templateUrl: 'competition-navigation.component.html',
    imports: [CompetitionTreeComponent],
})
export class CompetitionNavigationComponent {
    @Input() sport: CountItem;
    @Input() context: CompetitionRoute;
    @Input() tournaments: Tournament[];
}
